export interface ColorPalette {
	name: string,
	primaryColor: string,
	secondaryColor: string,
	accentColor: string,
	backgroundColor: string,
	textColor: string,
	cardColor: string,
	borderColor: string
}

// Predefined color palettes
export const colorPalettes: ColorPalette[] = [
	{
		name: 'Ocean Blue',
		primaryColor: '#0ea5e9',
		secondaryColor: '#06b6d4',
		accentColor: '#3b82f6',
		backgroundColor: '#f8fafc',
		textColor: '#1e293b',
		cardColor: '#ffffff',
		borderColor: '#e2e8f0'
	},
	{
		name: 'Forest Green',
		primaryColor: '#059669',
		secondaryColor: '#10b981',
		accentColor: '#34d399',
		backgroundColor: '#f0fdf4',
		textColor: '#1f2937',
		cardColor: '#ffffff',
		borderColor: '#d1fae5'
	},
	{
		name: 'Sunset Orange',
		primaryColor: '#ea580c',
		secondaryColor: '#f97316',
		accentColor: '#fb923c',
		backgroundColor: '#fff7ed',
		textColor: '#1c1917',
		cardColor: '#ffffff',
		borderColor: '#fed7aa'
	},
	{
		name: 'Royal Purple',
		primaryColor: '#7c3aed',
		secondaryColor: '#8b5cf6',
		accentColor: '#a78bfa',
		backgroundColor: '#faf5ff',
		textColor: '#1f2937',
		cardColor: '#ffffff',
		borderColor: '#e9d5ff'
	},
	{
		name: 'Elegant Rose',
		primaryColor: '#e11d48',
		secondaryColor: '#f43f5e',
		accentColor: '#fb7185',
		backgroundColor: '#fdf2f8',
		textColor: '#1f2937',
		cardColor: '#ffffff',
		borderColor: '#fce7f3'
	},
	{
		name: 'Midnight Dark',
		primaryColor: '#6366f1',
		secondaryColor: '#8b5cf6',
		accentColor: '#a855f7',
		backgroundColor: '#0f172a',
		textColor: '#f1f5f9',
		cardColor: '#1e293b',
		borderColor: '#334155'
	}
];